
<template>
  <div class="contract-wrap">
    <div class="contract-content">
      <div class="contract-back"></div>
      <div class="contract-stop-heat">
        <div class="contract-text">
          <div class="contract-text-box" v-if="showNonResident == null"></div>
          <div class="contract-text-box" v-if="showNonResident == 0" v-cloak>
            <div
              style="
                text-align: center;
                font-size: 0.18rem;
                font-weight: bold;
                margin-bottom: 0.2rem;
                opacity: 1;
                color: #333333;
              "
            >
              承德市双滦区居民供热用热合同
              <div style="font-size: 0.14rem; font-weight: 400">（2026版）</div>
            </div>
            <div class="contract-text-content">
              <p>
                根据《中华人民共和国民法典》、《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》等法律、法规和规章的规定，甲、乙方在自愿、平等、公平、诚实信用的基础上，协商订立本合同。
              </p>

              <p style="font-weight: 700">第一条 用热信息</p>
              <p>
                1.收费标准：（1）按面积计费的：23.00
                元/㎡。如遇价格调整，按照价格主管部门文件执行。（2）按热计量计费的：基本热价6.90元/㎡,计量热价0.188元/千瓦时，(供热前先按面积预交热费，供热结束后实际热费与面积热费的差额，在预交下一年热费时折抵或补交。因热计量表损坏，没有热计量计费依据时，按面积计费方式计费)。如遇热计量价格调整，按照价格主管部门文件执行。
              </p>
              <p>
                2.交费时间：乙方除申请停热并签订《停热协议》外，应于当年10月31日前将热费按供热期全额缴清。
              </p>
              <p>
                3.乙方户内采暖方式：以开发建设单位原设计的采暖方式为准，未经甲方书面同意不得擅自变更。（如未经甲方书面同意，乙方擅自改变采暖方式的，所造成的一切后果均由乙方自行承担）。
              </p>

              <p style="font-weight: 700">第二条 供热时间</p>
              <p>
                从每年11月1日0时起至次年3月31日24时止。因特殊天气，市、区政府调整供热时间的，按调整后的时间执行。
              </p>

              <p style="font-weight: 700">第三条 供热室内温度标准</p>
              <p>
                在供热期内，除不可抗力和乙方原因外，甲方应当提供足够热量，保障乙方在周边用热环境良好并装有合格用热设施的卧室、起居室(厅)的室温不低于18℃,其他部位应当符合设计规范标准要求。
              </p>

              <p style="font-weight: 700">第四条 供热设施管理责任</p>
              <p style="font-weight: 700">（一）管理界限划分</p>
              <p>1.有管道井的楼栋，以管道井内的穿墙管距户外墙体最近的一道阀门为界点。</p>
              <p>2.无管道井的楼栋，以距入户墙体最近一道阀门为界点。</p>
              <p>
                3.居民既有建筑自行申请入网，并在《入网合同》中对供热设施维护管理分界点有明确约定的从其约定。
              </p>
              <p>
                分界点以外（含一二次管网、热力站、楼内主管及户外阀门管件等），由甲方负责维护管理并承担费用。
              </p>
              <p>
                分界点以内（含乙方自用的户外穿墙管至户内分水器、地暖管或散热片、阀门管件等），由乙方负责维护管理并承担费用。
              </p>
              <p>（二）乙方户内共用供热设施，由甲方负责维护管理并承担费用。</p>
              <p style="font-weight: 700">（三）供热计量设施的维护管理责任</p>
              <p>
                1.热计量设施、室温监测装置由甲方负责安装、拆卸、维修和更换，费用纳入供热成本；人为损坏、丢失的由乙方承担赔偿责任。
              </p>
              <p>
                2.乙方应当保护热计量设施的安全，发现自用热计量装置丢失或损坏或发现可疑人员擅自改动、破坏供热计量设施的，应及时向甲方或公安机关报告。
              </p>
              <p style="font-weight: 700">（四）热计量表故障处理</p>
              <p>
                1.甲方或乙方对计量表的准确性产生异议或初步判定热计量表发生故障时，均不得随意拆卸、维修。应及时通知对方，并按下述原则处理：
              </p>
              <p>
                （1）经甲方判定，热计量表出现故障而无法修复时，属于正常损坏的，由甲方负责更换；属于人为破坏或丢失的，由责任人承担。责任人难以确定的，由受益人承担，没有受益人的，由甲乙方共同分担。
              </p>
              <p>
                （2）经甲方判定热计量表使用情况正常，但乙方仍有异议时，双方约定日期由甲方拆卸，乙方到法定计量检定机构进行检定，检定费用暂由乙方垫付。经检定，若计量表合格，则检定费由乙方承担。若热计量表的准确性确有问题时，则检定费由甲方承担，热计量表处置按上述（1）原则处理。
              </p>
              <p>2.采暖期内热表发生故障或失去计量依据时，热费结算方式：</p>
              <p>
                从甲、乙方发现热表发生故障或失去计量依据时起，之前的热费仍按双方确认的热表读数结算，发生故障或失去计量依据期间的热费按面积收费标准结算。
              </p>
              <p>3.因管序交叉导致两户之间热计量数据交叉的，由甲方负责协调，按实际数据多退少补。</p>

              <p style="font-weight: 700">第五条 甲方权利义务</p>
              <p>
                1.在供热期内，应当按本合同约定的时间、地点和温度标准向乙方连续稳定供热，保证乙方室内温度达标。
              </p>
              <p>
                2.甲方有权按合同约定向乙方收取热费，并按发票管理相关规定向乙方开具热费发票。乙方应当按照供热用热合同约定及时缴纳热费。逾期未缴纳的，甲方应当催告，经催告满十五日仍未缴纳的，在不损害其他用户权益的情况下，可对其中止供热。
              </p>
              <p>
                3.乙方缴清热费后，甲方应在3日内恢复供热。乙方拒不缴纳热费的，甲方可以停止供热或拆除供热设施或向人民法院提起诉讼。
              </p>
              <p>
                4.甲方不得将热费与物业费、水电费等其他费用捆绑收取，不得因不缴物业费、水电费等费用而拒收热费和限制用热。
              </p>
              <p>5.在供热期内，因设备设施故障或者不可抗力原因影响对乙方正常供热的，应当立即组织抢修。</p>
              <p>
                6.有权对乙方的用热情况进行监督和检查。监督乙方在合同约定的地点、数量、范围内用热，制止违规、违约用热行为。
              </p>
              <p>
                7.乙方人为破坏热计量装置、伪造供热记录的，甲方有权要求乙方立即改正，恢复原状并承担费用。拒不恢复的，甲方有权停止供热。
              </p>
              <p>
                8.甲方可通过现场张贴、微信公众号、新闻媒体等方式主动公开服务内容、服务标准、办事程序、收费标准和服务电话。供热期实行24小时不间断服务，及时、有效处置热用户查询、报修等服务申请。
              </p>
              <p>
                9.对乙方负责维护管理的供热设施发生故障向甲方报修的，甲方应当及时上门维修、抢修或委托第三方上门维修、抢修，产生的相关费用由乙方自行承担。甲方在维修、抢修过程中因甲方故意造成乙方财产损失的，甲方应承担相应赔偿责任。
              </p>
              <p>
                10.甲方应在接收乙方反映室温不达标情况12小时内入户排查，能当场解决的问题当场解决，当场不能解决的，可另行约定时间尽快排除故障。需要规范检测室温的，测温结果由双方签字确认。双方对室温检测有争议的，可以向供热主管部门申请测温。因甲方原因造成室温不达标的，应当按照本合同约定退还部分热费（非甲方原因除外）。
              </p>
              <p>11.甲方在对乙方室内供热设施进行检查、维修时，应当出示有效证件，文明服务。</p>
              <p>
                12.履行《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》及本合同其他条款中规定的应当由其承担的义务。
              </p>

              <p style="font-weight: 700">第六条 乙方权利义务</p>
              <p>1.有权要求甲方按合同约定的时间、地点和温度标准供热。</p>
              <p>
                2.应当按照有关规定和合同约定及时足额缴纳热费，对不符合价格主管部门规定收费的，乙方有权拒付。
              </p>
              <p>
                3.乙方认为室温不达标的，可以向甲方反映并申请上门服务，甲方按规范检测室温，如实填写测温记录。对室温检测有争议的，可以向供热主管部门申请测温。未经甲方或供热主管部门测温的，甲方不予认可。
              </p>
              <p>
                4.乙方应当对自有产权的供热设施定期维护、及时检修，对超出安全使用年限、影响采暖质量、存在安全隐患的自用采暖设施应当及时更新、更换。因维护管理或检修不到位造成不利后果的，由乙方承担全部责任。
              </p>
              <p>
                5.归乙方维护管理的供用热设施发生异常、泄漏等故障时，可以向甲方报修，但需乙方承担维修、更换的相关费用。在甲方维护管理室内共用供热设施时，应积极协助与配合。因室内装饰装修影响甲方维护管理的，乙方应当配合消除；非因甲方原因造成跑水、漏水或因乙方抢修、维修，给甲、乙方或第三方造成财产损失的，由乙方承担责任。
              </p>
              <p>6.乙方不得实施下列行为:</p>
              <p>（1）在室内供热设施上安装换热装置；</p>
              <p>（2）从供热设施中取用供热循环水；</p>
              <p>
                （3）擅自改动或者私接供热管道、增设散热器、扩大用热面积、改变房屋结构，导致两个供热系统的管道交叉、房屋相通、影响供热效果甚至无法用热；
              </p>
              <p>（4）在供热管道上安装管道泵；</p>
              <p>（5）私自开启入户阀门用热；</p>
              <p>（6）未采取断管、隔离等措施带水带压施工；</p>
              <p>（7）其他妨碍供热设施正常运行的行为。</p>
              <p>
                乙方实施上述行为的，甲方有权采取停止或者限制供热措施。给其他热用户或者给甲方造成损失的，乙方应承担相应赔偿责任。
              </p>
              <p>
                7.在甲方进行供热系统充水、试压、排气及试运行等工作时要留人监守；在甲方进行检查、维修、排气、室温抽测、查表、收费或采取紧急避险措施需要入户作业时，应当予以配合。如乙方不配合甲方工作，造成损失扩大的，由乙方承担相关责任。乙方发现共用管道、管件、设备丢失损坏的应及时向甲方或所在地居委会报告。
              </p>
              <p>8.在乙方将房屋出售或转让前，应将热费结清。</p>
              <p>
                9.<span style="font-weight: 700"
                  >乙方认可甲方以下列形式中的任何一项进行通知的效力：在小区张贴告示、在“双滦热力”微信公众号发布通知、向乙方预留的联系电话发送短信，均视为乙方已收到相关通知。</span
                >
              </p>
              <p>
                10.履行《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》及本合同其他条款中规定的应当由其承担的义务。
              </p>
              <p>11.预留通讯地址、电话准确有效，信息变更应及时告知甲方，否则视为送达有效。</p>

              <p style="font-weight: 700">第七条 违约责任</p>
              <p style="font-weight: 700">（一）甲方违约责任</p>
              <p>
                1.甲方未按合同约定时间向乙方供热，或因设备设施故障原因连续停止供热24小时以上的，应当按照以下方式退还相应费用：
              </p>
              <p>退费额=日平均热费×未供热天数。</p>
              <p>日平均热费=热费总额/本供热期法定供热天数。</p>
              <p>
                未供热天数：甲方未按合同约定时间迟延供热、提前结束供热的天数，以及供热期内停止供热的天数。
              </p>
              <p>
                2.按照规范检测方法，经过3次（每间隔30天左右检测1次），双方共同确认或第三方检测机构认定，乙方卧室、起居室(厅)
                室内平均温度未达到本合同约定标准的，甲方应当退还乙方相应的热费。
              </p>
              <p>
                3.非甲方原因导致室温不达标的，甲方不承担违约责任。如：由于不可抗力的原因造成停止供热或延迟供热，使乙方受到损失的；乙方擅自改变房屋结构扩大供热面积、擅自拆改供用热设施或改变采暖方式的；不及时维护维修或更换室内供热设施的；室内装修不当（遮挡采暖器）或保温措施不当的。
              </p>
              <p>
                4.因暂停供热导致的室温不达标，由甲方按照《暂停供热协议》与停热方沟通协调、妥善解决。
              </p>
              <p>
                5.甲方退还乙方的热费，不以现金形式退还，退还热费直接转存作为下年度供热费用使用。因特殊情况不能转下年使用的另行协商。
              </p>
              <p style="font-weight: 700">（二）乙方违约责任</p>
              <p>
                1.乙方未按合同约定的时间及数额交纳热费，自11月1日起，时间每推迟一天,按应缴热费总额的1‰支付违约金（最高不超热费总额30%）。经催告仍不交纳的，甲方可以对其限制或停止供热，并向供热主管部门备案。
              </p>
              <p>
                2.乙方实施本合同第六条第六项规定的妨碍供热设施正常运行的行为，甲方有权停止/限制供热，责令恢复原状，赔偿损失。
              </p>
              <p>
                3.擅自接入供热管网或擅自扩大用热面积、私放或利用供热循环水、擅自开启供热阀门均属窃热行为，情节严重的可能构成犯罪。乙方如有上述行为，应按热费金额的3倍或按私自排放供热循环水价值的3倍承担违约责任。
              </p>
              <p>
                4.因乙方出租、出售或转让房屋拖欠热费的，甲方有权停止供热。新、老用热用户（统称为“乙方”）应承担连带缴费义务。
              </p>
              <p>
                5.擅自安装管道泵和换热装置、增设散热器或有其他违规用热行为的，应恢复原状并赔偿甲方因此受到的损失。
              </p>
              <p>
                6.乙方无故拒绝、阻挠甲方进行共用供热设施维护管理或更新改造，导致甲方无法供热或给甲、乙方及第三方造成损失的，一切后果均由乙方承担。
              </p>
              <p>7.违反《治安管理处罚法》的，由公安机关依法处罚；构成犯罪的，依法追究刑事责任。</p>
              <p>8.因乙方室内设施漏水、违规操作造成自身或第三方损失，由乙方全额赔偿。</p>
              <p>
                9.因乙方违约被起诉的，除依法承担违约责任外，还应承担甲方因此支出的全部费用，包括但不限于诉讼费、律师费、交通费、保全费、执行费等。
              </p>
              <p style="font-weight: 700">第八条 其他约定</p>
              <p>
                1.在供用热设施保修期内甲方与开发建设单位或更新改造单位另有合同约定的，从其约定。
              </p>
              <p>2.热计量用户，已按面积预交纳热费的，热费结算后应该多退少补的部分，均不计违约金。</p>
              <p style="font-weight: 700">3.室温检测与退费原则</p>
              <p>
                检测室温应当使用国家标准温度计，检测方法应当符合相关技术规范要求。具体测温时间由甲乙方协商约定。一般在乙方投诉室温不达标的时段进行。
              </p>
              <p>
                4.因甲方供热原因导致室温不达标的，应按不达标的卧室、起居室面积，不达标时间和实际温度与标准温度相差多少计算退费金额。
              </p>
              <p>
                5.因乙方阁楼或复式房屋停热导致本户用热主体房屋室温不达标的，甲方不承担退费责任。
              </p>
              <p>
                6.因乙方停热导致楼上或楼下用户卧室和起居室（厅）不达标的，按照甲、乙双方另行签订的《暂停供热协议》办理。
              </p>
              <p>
                7.甲方支持保险机构为乙方开展家庭“漏水险”代办服务并为乙方交纳保费提供便利。因乙方未交纳“漏水险”保费，跑水、漏水造成损失的由乙方承担。
              </p>

              <p style="font-weight: 700">第九条 合同的变更</p>
              <p>
                1.乙方用热房屋的产权关系发生变更时，应当及时解除本合同，并将热费结清。因未解除本合同也未结清热费引发供用热纠纷的，由乙方自行承担责任。
              </p>
              <p>
                2.乙方在合同有效期内申请暂停供热的，应在当年9月30日前提出申请，甲方依据有关政策规定，在具备分户关闭条件、且不影响其他热用户正常用热和共用供热设施安全运行的前提下，采取措施为乙方办理暂停供热并签订《暂停供热协议》。暂停供热期间热费（含停热费）按照有关政策执行。用热户未与供热单位签订供用热合同，或在规定时间内未签订《暂停供热协议》而形成事实用热的，用热户应当交纳热费。暂停供热或恢复供热的具体事宜由双方在《暂停供热协议》中另行约定。
              </p>
              <p>
                3.本合同约定事项为基本要求，双方另行约定的事项不得低于本合同约定。法律、法规、规章和标准、规范对合同内容另有强制性规定的，从其规定。
              </p>

              <p style="font-weight: 700">第十条 合同的生效</p>
              <p>
                1.本合同自双方签字、盖章之日起生效，有效期为1年。合同有效期届满，如双方未订立新合同，本合同自动延续。在《暂停供热协议》有效期内，双方另有约定的从其约定。恢复供热后，本合同涉及权利义务等重要内容没有变化的，可继续履行本合同；权利义务等重要内容有变化的，按新合同执行。
              </p>
              <p>
                2.本合同如有未尽事宜，经双方协商一致，可另行签订补充协议作为本合同附件。补充协议与本合同具有同等法律效力。
              </p>

              <p style="font-weight: 700">第十一条 争议解决方式</p>
              <p>
                本合同项下发生的民事争议，由双方协商解决，或向消费者协会、供热协会、供热主管部门申请调解；协商或调解不成的，任何一方均可向双滦区人民法院提起诉讼。
              </p>
              <p>本合同一式 2 份，甲方1 份，乙方 1 份。本合同及附件等均具有同等法律效力。</p>
            </div>
          </div>
          <div class="contract-text-box" v-if="showNonResident == 1" v-cloak>
            <div
              style="
                text-align: center;
                font-size: 0.18rem;
                font-weight: bold;
                margin-bottom: 0.2rem;
                opacity: 1;
                color: #333333;
              "
            >
              承德市双滦区非居民供热用热合同
              <div style="font-size: 0.14rem; font-weight: 400">（2026版）</div>
            </div>
            <div class="contract-text-content">
              <p>
                根据《中华人民共和国民法典》、《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》等法律、法规及政策规定，甲、乙方在自愿、平等、公平、诚实信用的基础上，订立本合同。
              </p>

              <p style="font-weight: 700">第一条 用热信息</p>
              <p>
                1.收费标准：（1）按面积收费的32.00
                元/㎡。如遇供热价格调整，按照价格主管部门的收费文件执行。（2）按供热计量收费的基本热价：9.60元/㎡,计量热价0.298元/千瓦时，(供热前先按照面积预交热费，供热结束后实际热费与面积热费的差额，在预交下一采暖季热费时多退少补)。如遇供热计量价格调整，按照价格主管部门的收费文件执行。
              </p>
              <p>
                2.缴费时间：乙方正常采暖的应于当年10月31日前将热费全额缴清（实行热计量计费的先按面积预缴费）；办理暂停供热手续的，同时缴纳停热费。
              </p>
              <p>
                3.乙方户内采暖方式：以原始设计的采暖方式为准。未经甲方书面同意，乙方不得擅自改变，否则一切后果自负。
              </p>

              <p style="font-weight: 700">第二条 供热时间</p>
              <p>
                从每年11月1日0时起至次年3月31日24时止。如遇特殊天气，市、区政府调整供热时间的，按政府文件执行。
              </p>

              <p style="font-weight: 700">第三条 供热温度标准</p>
              <p>
                甲方对非居民与居民用户同等供热，但因非居民与居民房屋保温性能和用热环境不同，<span
                  style="font-weight: 700"
                  >办公用房一般不低于16℃；商业用房一般不低于14℃（因平房无外墙保温、密闭性较差、房屋散热量较大，故无法保证室内温度）</span
                >。乙方若采取房屋保温措施或改善用热环境，即可提升室内采暖温度。
              </p>

              <p style="font-weight: 700">第四条 供热设施产权界定与维护管理</p>
              <p>
                （一）根据《入网合同》约定，以乙方入网建筑物与甲方供热管网碰头的阀门法兰为分界点（一般在建筑物外的供热井室内）。分界点以外（供热侧，含一二次管网、换热站、井室及控制阀门等）的供热设施归甲方所有，由甲方负责维护管理和更新；分界点以内（用热侧，含穿墙管、建筑物内管道、阀门、管件、暖气片或分水器、地暖管等）的供热设施归乙方所有，由乙方自行维护管理和更新。
              </p>
              <p style="font-weight: 700">（二）共用设施维护管理特殊约定</p>
              <p>
                在建筑物内乙方与其他用户共用供热设施的特殊情况，按下列办法界定维护管理界限：
              </p>
              <p>
                1.在乙方室内的共用供热设施（包括非居民与非居民共用和非居民与居民共用），由乙方维护管理和更新；属于居民共用部分，在乙方室外公共部位的，由甲方维护管理和更新。
              </p>
              <p>
                2.因乙方装饰装修，包裹、覆盖居民共用供热设施或因未尽维护管理责任，导致跑水漏水或无法供热的，由乙方承担全部责任。
              </p>
              <p>
                3.居民共用供热设施在乙方室内的，应由乙方配合甲方将居民共用供热设施迁移至室外或公共空间。没有迁移至室外或公共空间的，由乙方负责。
              </p>
              <p>
                4.甲、乙方在《入网合同》、《首年开栓供热合同》、《供热设施更新改造移交合同》和《临时供热合同》中，对维护管理界限和维护管理责任另有明确约定的，从其约定。
              </p>
              <p>
                （三）在乙方维护管理范围内的供热设施发生异常、泄漏等故障时，乙方可以向甲方或第三方报修，但需自行承担相关费用。乙方需要第三方提供有偿维修服务的，可联系：5913666或关注微信公众号：“承德水暖维修”。
              </p>
              <p style="font-weight: 700">（四）供热计量设施的维护管理责任</p>
              <p>
                1.热计量设施的安装、拆卸、维修和更换，由甲方负责（乙方自行加装热计量设施并在相关合同中另有约定的从其约定）。乙方擅自拆改、损坏、丢失的，由乙方承担费用及赔偿。
              </p>
              <p>
                2.乙方应当保护热计量设施的安全，发现自用热计量装置丢失或损坏或发现可疑人员擅自改动、破坏供热计量设施的，应及时向甲方或公安机关报告。
              </p>
              <p style="font-weight: 700">（五）热计量表故障处理</p>
              <p>
                1.甲方或乙方对计量表的准确性产生异议或初步判定热计量表发生故障时，均不得随意拆卸、维修。应及时通知对方，并按下述原则处理：
              </p>
              <p>
                （1）经甲方判定：热计量表出现故障而无法修复时，属于正常损坏的，由甲方负责更换；属于人为破坏或丢失的，由责任人承担。责任人难以确定的，由受益人承担；没有受益人的，由甲乙方共同分担。
              </p>
              <p>
                （2）经甲方判定：热计量表使用情况正常，但乙方仍有异议时，双方约定日期由甲方拆卸，乙方到法定计量检定机构进行检定，检定费用暂由乙方垫付。经检定，若计量表合格，则检定费由乙方承担；若热计量表的准确性确有问题时，则检定费由甲方承担，热计量表处置按上述（1）原则处理。
              </p>
              <p>2.采暖期内热表发生故障或失去计量依据时，热费结算方式：</p>
              <p>
                从甲、乙方发现热表发生故障或失去计量依据时起，之前的热费仍按双方确认的热表读数结算；发生故障或失去计量依据期间的热费按面积收费标准结算。
              </p>
              <p>3.因管序交叉导致两户之间热计量数据交叉的，由甲方负责协调，按实际数据多退少补。</p>

              <p style="font-weight: 700">第五条 甲方的权利义务</p>
              <p>1.在供热期内，甲方应当按本合同约定的时间、地点和温度标准向乙方连续稳定供热。</p>
              <p>
                2.有权按本合同约定向乙方收取热费或停热费，并向乙方开具发票。对乙方逾期未缴纳热费或停热费的可以催告。经催告仍未缴纳热费的，甲方有权限制或停止供热，乙方缴清热费后，甲方应在24小时内恢复供热。甲方停止供热后，乙方仍拒不缴纳热费或停热费的，可以拆除供热设施或向双滦区人民法院提起诉讼。
              </p>
              <p>3.甲方不得将热费与物业费、水电费等其他费用捆绑收取。</p>
              <p>
                4.在供热期内，因甲方设施设备故障或者不可抗力原因影响为乙方正常采暖的，应立即组织抢修，停热超过24小时的应及时公告。
              </p>
              <p>
                5.有权对乙方的用热情况进行监督检查。监督其在合同约定的地点、数量、范围内用热，制止违规用热行为。
              </p>
              <p>
                6.乙方擅自改变采暖方式、破坏热计量装置、伪造供热记录的，甲方有权要求乙方立即改正，恢复原状并承担费用。拒不改正的，甲方有权停止供热。
              </p>
              <p>
                7.甲方应当通过现场张贴、微信公众号、新闻媒体等方式主动公开服务内容、服务标准、办事程序、收费标准和服务电话。
              </p>
              <p>
                8.接到乙方报修申请应当及时处置。在抢修、维修过程中因甲方故意造成乙方财产损失的，应当承担相应赔偿责任。
              </p>
              <p>
                9.乙方反映室温不达标的，甲方应在12小时内进行现场排查，能当场解决的当场解决，当场不能解决的，可提出解决方案，尽快排除故障。需要规范检测室温的，测温结果由双方签字确认。双方对室温检测有争议的，可以向供热主管部门申请测温。因甲方原因造成室温不达标的，应按照本合同约定退还部分热费（不是甲方原因的除外）。
              </p>
              <p>
                10.实行规范化管理，并为乙方提供24小时查询、报修等服务，公开客户服务电话：<span
                  style="border-bottom: 1px solid #333; font-weight: 700"
                  >966011</span
                >
              </p>
              <p>11.甲方进入乙方室内进行检查时，应当出示有效证件，文明服务。</p>
              <p>
                12.履行《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》及本合同其他条款中应当由其承担的义务。
              </p>

              <p style="font-weight: 700">第六条 乙方权利义务</p>
              <p>1.有权要求甲方按合同约定的时间、地点和温度标准供热。</p>
              <p>
                2.应当按照国家有关规定和合同约定及时足额缴纳热费或停热费，对甲方不按规定标准收取的有权拒付。
              </p>
              <p>
                3.乙方认为室温不达标的，可以向甲方反映并申请上门服务，甲方按规范检测室内温度，应如实填写测温记录。
              </p>
              <p>
                4.应当对维护管理范围内的供热设施，定期维护、及时检修。发生异常、泄漏等故障时，可以向甲方报修，但需乙方自行承担费用。
              </p>
              <p>
                5.因乙方原因导致跑水、漏水或抢修、维修，给自身和他人造成财产损失的，由乙方承担责任。
              </p>
              <p>
                6.乙方的房屋，必须具有独立的供热系统和空间。不能与其他房屋的供热管道或空间相通。
              </p>
              <p>
                7.在甲方向管道注水、试压等工作时应留人监守；在进入室内检查、排气、测温等工作时应当予以配合；发现有人破坏共用供热设施设备或已经损坏的，应及时向甲方或有关部门报告。因乙方过错给自身和他人造成损失的，应承担相应赔偿责任。
              </p>
              <p>
                8.乙方增加用热项目或新增用热面积，必须向甲方申请办理用热手续，并按规定缴纳相关费用。乙方出售、转让房屋的，应向甲方办理变更手续。
              </p>
              <p>
                9.<span style="font-weight: 700"
                  >乙方将房屋出售或转让他人的，应提前办理变更并结清费用。否则，不免除乙方缴纳热费或停热费的义务，因此引发供用热纠纷的，由乙方自行解决。</span
                >
              </p>
              <p>10.乙方在甲方登记的联系电话、开户银行或者账户、账号如有变更，应当及时书面告知甲方。</p>
              <p>
                11.<span style="font-weight: 700"
                  >乙方认可甲方以下列形式中的任一项进行通知的效力：在小区或建筑物上张贴告示、通过“双滦热力”微信公众号发布通知、向乙方预留的联系电话发送短信，均视为乙方已收到相关通知。</span
                >
              </p>
              <p>
                12.履行《河北省供热用热管理规定》、《河北省供热用热办法》、《承德市城市供热条例》及本合同其他条款中应当由其承担的义务。
              </p>

              <p style="font-weight: 700">第七条 暂时停止供热</p>
              <p>
                （一）在乙方具备停热条件（独立供热系统、独立房屋、可分户控制、不影响其他用户正常采暖和共用供热设施安全运行）的前提下，要求整个采暖季暂停供热的，应在<span
                  style="font-weight: 700"
                  >当年的9月30日前</span
                >，按政策规定缴纳停热费并签订《暂停供热协议》。连续停热的，应办理停热手续并按政策规定缴纳停热费。停热期间，双方应按《暂停供热协议》履行权利和义务并承担违约责任。
              </p>
              <p style="font-weight: 700">（二）有下列情形之一的,乙方不得申请暂停供热：</p>
              <p>1.不能分户控制的；</p>
              <p>2.停热房屋与用热房屋管路、空间相通的；</p>
              <p>3.影响其他用户正常用热的；</p>
              <p>4.具有违规用热行为，尚未解决的。</p>
              <p style="font-weight: 700">第八条 乙方不得实施下列行为</p>
              <p>
                （一）擅自改动室内供热设施、改变用热方式（包括暖气片改地暖管或地暖管改暖气片等）；
              </p>
              <p>（二）擅自扩大用热面积、增加散热设备或者改变房屋结构；</p>
              <p>（三）擅自在供热设施上安装换热装置、放水阀、管道泵；</p>
              <p>（四）排放或者取用供热循环水；</p>
              <p>（五）私自开启、调节、移动、拆除供热阀门及铅封、计量器具等；</p>
              <p>
                （六）改动、破坏、拆除供热设施（含拆改锁闭阀，拆改、占用管道井等）、计量表及温控装置；
              </p>
              <p>（七）阻碍甲方对居民共用供热设施进行维护、管理；</p>
              <p>
                （八）违反《承德市城市供热条例》第14条规定，在供热设施安全保护范围内，实施影响供热
                设施安全的行为；
              </p>
              <p>（九）其他影响供热设施正常运行和供热质量的行为。</p>
              <p>
                乙方实施上述行为，导致室温不达标的自行负责，给甲方和其他用户造成损失的，应承担赔偿责任。
              </p>

              <p style="font-weight: 700">第九条 违约责任</p>
              <p style="font-weight: 700">（一）甲方的违约责任：</p>
              <p>
                1.供热期内，如因甲方责任致使乙方未达到合同约定的供热质量标准的，经双方共同确认或由供热主管部门检测认定后，甲方应按本合同约定退还相应热费。但<span
                  style="font-weight: 700"
                  >由于乙方违规用热、房屋围护达不到节能建筑标准、相邻用户停热、采暖设施不符合供热技术要求，又不落实甲方整改建议等非甲方原因导致室温不达标的，甲方免责，不承担退费责任。诸如下列原因</span
                >：
              </p>
              <p>（1）乙方实施了本合同第八条所列违规行为之一的；</p>
              <p>
                （2）<span style="font-weight: 700">乙方房屋为平房或未经节能改造的老旧房屋</span
                >（外墙无保温或门窗跑风漏气等）<span style="font-weight: 700"
                  >又不采取保温措施的</span
                >；
              </p>
              <p>（3）乙方自用采暖系统年久失修、严重老化、堵塞或未按甲方提出的建议整改的；</p>
              <p>
                （4）<span style="font-weight: 700"
                  >装饰装修遮挡采暖器、地暖管被木地板或落地家具覆盖的；</span
                >
              </p>
              <p>（5）甲方对供热设施正常检修、抢修时间在24小时以内或属于供热调试运行期间的；</p>
              <p>（6）特殊天气，室外日平均气温低于-12.6℃的；</p>
              <p>（7）市政府决定对电力、自来水等采取限量供应措施的；</p>
              <p>（8）属于不可抗力造成停止供热、延误供热等；</p>
              <p>（9）相邻用户停热、用热环境异常的；</p>
              <p>（10）其他不可抗力及政府行为。</p>
              <p style="font-weight: 700">（二）乙方的违约责任：</p>
              <p>
                1.未按本合同约定的时间及数额支付热费或未按《暂停供热协议》缴纳停热费的，<span
                  style="font-weight: 700"
                  >自当年11月1日起，按日1‰支付违约金</span
                >（最高不超过本金30%）。经催告后仍未缴纳的，甲方有权停止供热或拆除供热设施直至依法起诉，一切后果均由乙方承担。
              </p>
              <p>
                2.乙方的下列行为给甲方和他人造成损失的，应承担相应的赔偿责任：
              </p>
              <p>（1）对产权、维护管理范围内的供热设施未履行管护义务或因自用供热设施损坏、泄漏的；</p>
              <p>（2）违反操作规程，擅自拆改自用供热设施产生泄漏或影响他人用热的；</p>
              <p>（3）拆改热计量装置的；</p>
              <p>（4）排放或取用供热循环水的；</p>
              <p>（5）拒绝甲方入户作业或拒绝甲方整改建议的；</p>
              <p>（6）其他违反国家有关规定和本合同约定的行为，给甲方和他人造成损失的。</p>
              <p>
                3.按热计量计费的，因人为因素导致不能正常计量，又拒绝修复或者因管道次序交叉，计量数据颠倒，乙方拒不退还另一方热费的，甲方有权停止供热。
              </p>
              <p>
                4.乙方在自用供热设施上安装换热装置或擅自安装管道泵的应自行拆除。拒绝拆除的，甲方有权停止供热或移交有关部门依法处理。
              </p>
              <p>
                5.未经甲方同意，乙方擅自改动供热管道、改变采暖方式、增设散热器的，应当恢复原状并赔偿甲方因此受到的损失。
              </p>
              <p>
                6.乙方擅自接入甲方供热管网或扩大用热面积的，应补缴入网费和热费。擅自接入或扩大用热面积的时间难以确定的，按房屋使用时间或开始供热时间计算，并按热费的1-3倍计收违约金。
              </p>
              <p>7.乙方被停止供热后，满12个月仍未接受处理的，视为自行退网。</p>
              <p>
                8.因乙方干扰或阻挠甲方对居民共用供热设施进行维护维修或更新改造，给甲方或第三方造成损失的，均由乙方承担责任。
              </p>
              <p>9.乙方违反《治安管理处罚法》的，由公安机关依法处罚；构成犯罪的，依法追究刑事责任。</p>
              <p>
                10.因乙方被起诉的，除依法赔偿或承担违约责任外，还应承担甲方因此支出的全部费用，包括但不限于诉讼费、律师费、交通费、保全费、执行费等。
              </p>

              <p style="font-weight: 700">第十条 其他约定</p>
              <p>
                1.热计量用户，已按面积预交热费，供热结束后按照供热计量政策，多退或少补部分均不计违约金。
              </p>
              <p style="font-weight: 700">2.室温检测与退费原则</p>
              <p>
                检测室温应当使用国家标准温度计，检测方法应当符合相关技术规范要求。具体测温时间由双方约定。一般在室温不达标的时间段进行。
              </p>
              <p>
                3.退费仅适用于甲方原因。因甲方供热原因导致室温持续不达标的，按实际不达标天数、实测温度与约定温度相差多少、折算退还相应热费。因乙方原因导致室温不足，包括但不限于供热设施损坏、自行控制热能消耗等导致室温不达标的，甲方不承担退费责任。
              </p>
              <p>
                4.擅自排放或取用供热循环水的，按照管道开始注水时间至发现时间，管道最大出水量，按每吨50元计算并赔偿。
              </p>

              <p style="font-weight: 700">第十一条 合同的变更</p>
              <p>
                乙方房屋的产权关系发生变更时，乙方应当结清全部费用并办理解除/变更手续。乙方未办理解除/变更手续的，应当继续承担本合同项下的应尽义务。
              </p>

              <p style="font-weight: 700">第十二条 合同的生效</p>
              <p>
                1.本合同自双方签字、盖章之日起生效，有效期为1年。合同有效期届满，如双方未订立新合同，本合同自动延续。在《暂停供热协议》有效期内，双方另有约定的从其约定。恢复供热后，本合同涉及权利义务等重要内容没有变化的，可继续履行本合同；权利义务等重要内容有变化的，按新合同执行。
              </p>
              <p>
                2.本合同约定事项为基本要求，双方另行约定的事项不得低于本合同约定。法律、法规、规章和标准、规范对合同内容另有强制性规定的，从其规定。
              </p>
              <p>
                3.本合同如有未尽事宜，经双方协商一致，可另行签订补充协议作为本合同附件。补充协议与本合同具有同等法律效力。
              </p>

              <p style="font-weight: 700">第十三条 争议解决方式</p>
              <p>
                本合同项下发生的民事争议，由双方协商解决，或向消费者协会、供热主管部门申请调解；协商或调解不成的，任何一方均可向双滦区人民法院提起诉讼。
              </p>
              <p>
                本合同正本一式 2 份，甲方1 份，乙方 1
                份。本合同正文及附件等均为本合同组成部分，具有同等法律效力。
              </p>
            </div>
          </div>
          <div class="contract-check">
            <div v-if="checkedFlag" @click="checkedFlag = false">
              <img
                src="../../assets/image/selected-icon.png"
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
                alt
              />
              <span class="agree-text">我已阅读并同意</span>
            </div>
            <div v-else @click="checkedFlag = true">
              <img
                src="../../assets/image/outcheck-icon.png"
                alt
                style="width: 0.16rem; height: 0.16rem; margin-top: 0.03rem"
              />
              <span class="agree-text">我已阅读并同意</span>
            </div>
          </div>
        </div>
        <div :class="checkedFlag ? 'contract-btn-check' : 'contract-btn'">
          <el-button type="primary" :disabled="enterDisabled" @click="gotoUserInfluence"
            >继续</el-button
          >
        </div>
        <div class="contract-btn">
          <el-button
            type="primary"
            style="
              background: rgba(0, 123, 131, 0.1);
              border: 1px solid rgba(0, 123, 131, 1);
              color: #007b83;
              opacity: 1;
            "
            @click="handleCancelClick"
            >取消</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showNonResident: null,
      showStopHeat: true,
      checkedFlag: false,
      enterDisabled: false,
    };
  },
  props: ['showContract'],
  created() {
    this.getWxPayInfo();
  },
  methods: {
    // 同意协议按钮
    gotoUserInfluence() {
      if (!this.checkedFlag) return;
      this.submitContract();
    },
    handleCancelClick() {
      this.$router.replace({
        name: 'index',
      });
    },
    async getWxPayInfo() {
      const { result: res } = await this.$http.get(this.$url.globalurl + '/wxPayInfo');
      console.log(res);
      this.showNonResident =
        !res.raw_data ||
        JSON.parse(res.raw_data).length == 0 ||
        !JSON.parse(res.raw_data)[0].userType ||
        JSON.parse(res.raw_data)[0].userType == '住宅'
          ? 0
          : 1;
    },
    async submitContract() {
      this.enterDisabled = true;
      const res = await this.$http.post(`${this.$url.globalurl}/wxHeatContract`);
      console.log(res);
      if (res.code == 200) {
        this.$emit('update:showContract', 0);
      }
      this.enterDisabled = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.contract-wrap {
  height: 100%;
  overflow: auto;
  margin: 0;
}
.contract-content {
  height: calc(100vh + 1px);
  position: relative;
  top: 0;
}
p {
  text-indent: 2em;
}
.contract-back {
  position: absolute;
  width: 100%;
  height: 0px;
  top: -0.2rem;
  padding-bottom: 25%;
  background-image: url(../../assets/image/bgtop.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.contract-text {
  position: relative;
  margin: 0.2rem;
  background: #fff;
  padding: 0.2rem 0 0.1rem 0.2rem;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0.2rem;
}
.contract-text-box {
  height: 70vh;
  line-height: 0.25rem;
}
.contract-text-box > div {
  color: rgba(51, 51, 51, 1);
  opacity: 0.8;
}
.contract-text-content {
  height: 59vh;
  overflow: auto;
  padding-right: 0.1rem;
}
.contract-stop-heat {
  padding-bottom: 0.2rem;
}
.line {
  font-weight: 700;
  display: inline-block;
  border-bottom: 1px solid #333;
}
.contract-text-box .contract-check-text {
  width: 2.7rem;
  color: rgba(51, 51, 51, 1);
  margin-left: 0.1rem;
  font-size: 0.12rem;
  opacity: 0.8;
}
.contract-check {
  display: flex;
  margin-top: 0.2rem;
  line-height: 0.2rem;
}
.contract-text-box .contract-outcheck-text {
  width: 2.7rem;
  margin-left: 0.1rem;
  font-size: 0.12rem;
  color: #007b83;
}
.contract-check > div {
  display: flex;
  height: 0.2rem;
  vertical-align: middle;
}
.agree-text {
  display: inline-block;
  height: 100%;
  // margin-left: 0.1rem;
}
.contract-btn,
.contract-btn-check {
  text-align: center;
  margin-top: 0.2rem;
}
// .contract-btn:last-child {
//   margin-bottom: 0.2rem;
// }
.contract-btn-check button {
  width: 2.7rem;
  padding: 4%;
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1);
}
.contract-wrap .el-button--primary:focus,
.el-button--primary:hover {
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1) !important;
}
.contract-btn button {
  width: 2.7rem;
  padding: 4%;
  border: 1px solid rgba(0, 123, 131, 1);
  background: rgba(0, 123, 131, 1);
  opacity: 0.5;
}
.contract-text-content::-webkit-scrollbar {
  width: 0.05rem;
  height: 0.05rem;
}
.contract-text-content::-webkit-scrollbar-corner {
  background: #909399;
}
.contract-text-content::-webkit-scrollbar-thumb {
  background: #909399;
}
.contract-text-content::-webkit-scrollbar-track {
  background: #eceef1;
}
[v-cloak] {
  display: none;
}
</style>